import { changeFilteredInfo } from "@/utils/data/tableCol/tableUtils";

export const deductionRecords = (filteredInfos) => {
    let filteredInfo = changeFilteredInfo(filteredInfos)
    return [
        {
            title: '操作',
            key: 'operation',
            scopedSlots: { customRender: 'operation' },
            width: 150
        },
        {
            title: '销售',
            dataIndex: 'sale.name',
            key: 'salesName',
                scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true
            },
            filteredValue: filteredInfo.salesName || []
        },
        {
            title: '客户联系人',
            dataIndex: 'contactName',
            key: 'customerContactsName',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true
            },
            filteredValue: filteredInfo.customerContactsName || []
        },
        {
            title: '扣除编号',
            dataIndex: 'deductionNumber',
            key: 'deductionNumber',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true
            },
            filteredValue: filteredInfo.deductionNumber || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '扣除类型',
            dataIndex: 'deductionType',
            key: 'deductionType',
            scopedSlots: {
                filterDropdown: 'filterType',
                filterIcon: 'filterIcon',
                filtered: true,
                customRender: 'deductionType'
            },
            filteredValue: filteredInfo.deductionType || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '金额',
            dataIndex: 'amount',
            key: 'amount',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.amount || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '创建人',
            dataIndex: 'createBy',
            key: 'createBy',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.createBy || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '创建时间',
            dataIndex: 'createTime',
            key: 'createTime',
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '备注',
            dataIndex: 'remark',
            key: 'remark',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.remark || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
    ]
}
